import React from "react";
import { NavLink } from "react-router-dom";
import { Clock, Table2, Hammer, User } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Fixed bottom tab bar for mobile viewports. Replaces the hidden desktop
 * navbar on phones. Tabs: Clock In · Timesheet · Tools (Tool Status) · Profile.
 */
export default function MobileTabBar() {
  const { user } = useAuth();

  if (!user) return null;

  // Tab config — data-testid attributes on every button per app rules.
  const tabs = [
    { to: "/clock", label: "Clock", Icon: Clock, testid: "mtab-clock" },
    { to: "/timesheet", label: "Timesheet", Icon: Table2, testid: "mtab-timesheet" },
    { to: "/stores/tool-status", label: "Tools", Icon: Hammer, testid: "mtab-tools" },
    { to: "/profile", label: "Profile", Icon: User, testid: "mtab-profile" },
  ];

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-summit-hairline"
      // safe-area padding for iOS home indicator
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-tab-bar"
    >
      <ul className={`grid grid-cols-${tabs.length}`} style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))` }}>
        {tabs.map(({ to, label, Icon, testid }) => (
          <li key={to} className="contents">
            <NavLink
              to={to}
              end={to === "/"}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-2 gap-0.5 transition-colors ${
                  isActive ? "text-summit-primary" : "text-gray-500 hover:text-summit-primary"
                }`
              }
              data-testid={testid}
            >
              {({ isActive }) => (
                <>
                  <Icon className={`w-5 h-5 ${isActive ? "" : "opacity-80"}`} strokeWidth={2} />
                  <span className="font-mono text-[9px] uppercase tracking-widest">{label}</span>
                  {isActive && (
                    <span className="w-1 h-1 bg-summit-primary rounded-full" aria-hidden="true" />
                  )}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
